<template>
  <article :class="getClass()" :id="'tease-' + item.id">
    <div :class="getImageClass()" v-if="itemStore.showImage">
      <img
        v-if="item.image.large"
        :src="item.image.large"
        :alt="item.image.alt"
      />
    </div>
    <h4 class="post-title">
      <button v-if="item.data['content']" class="contact-modal-trigger" type="button" @click="open = true">{{ item.title }}</button>
      <template v-else>{{ item.title }}</template>
    </h4>
    <p v-if="'title' in item.data" class="contact-jobtitle">
      {{ item.data["title"] }}
    </p>
    <a v-if="'phone' in item.data" class="contact-phone">{{
      item.data["phone"]
    }}</a>
    <p v-if="'email' in item.data && item.data['email'].split('@').length > 1">
      <a :href="'mailto:' + item.data['email']">
        {{ item.data["email"].split("@")[0] }}<wbr />@{{
          item.data["email"].split("@")[1]
        }}
      </a>
    </p>

    <Teleport to="body">
      <div
        v-if="item.data['content']"
        class="contact-modal-overlay"
        v-show="open"
        @click.self="open = false"
        @keydown.escape="open = false"
      >
        <div class="contact-modal-dialog">
          <button
            type="button"
            class="contact-modal-close"
            @click="open = false"
          >
            <i class="fa-regular fa-xmark"></i>
          </button>
          <div v-if="item.image.large" class="contact-modal-image">
            <img :src="item.image.large" :alt="item.image.alt" />
          </div>
          <div class="contact-modal-header">
            <h2 class="contact-modal-title">{{ item.title }}</h2>
          </div>
          <div class="contact-modal-body" v-html="item.data['content']"></div>
        </div>
      </div>
    </Teleport>
  </article>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useItemStore } from "@/itemStore";
import type { Item } from "@/itemStore";

const itemStore = useItemStore();

const props = defineProps<{
  item: Item;
  nr: number;
}>();

const open = ref(false);

const getClass = () => {
  let className = "tease";
  className += " tease-" + itemStore.type;
  props.item.primary.forEach((term) => {
    className += " tease-term-" + term.slug;
  });
  className += " tease-nr-" + props.nr;
  return className;
};

const getImageClass = () => {
  let className = "img-container";
  if (props.item.image.medium) {
    className += " has-image";
  } else {
    className += " img-placeholder";
  }
  return className;
};
</script>
